import React, { useCallback, useEffect, useState } from 'react';
import '../../../css/print.css';
import { useParams } from 'react-router-dom';
import { usePrescriptionToPrint } from './hooks/usePrescriptionToPrint';

export default function PrescriptionToControlledMedicinesToPrint() {
  const { patientId, prescriptionId } = useParams();

  const { fetchPrescriptionToPrint } = usePrescriptionToPrint();
  const [prescriptionToPrint, setPrescriptionToPrint] = useState(null);

  const getPrescriptionToPrint = useCallback(() => {
    fetchPrescriptionToPrint(patientId, prescriptionId)
      .then((returnFromApi) => {
        setPrescriptionToPrint(returnFromApi.data);
      })
      .catch((returnFromApi) => {
        console.error('ops! ocorreu um erro' + returnFromApi);
      });
  }, [patientId, prescriptionId, fetchPrescriptionToPrint]);

  useEffect(() => {
    getPrescriptionToPrint();

    const handleAfterPrint = () => {
      window.close();
    };
    document.body.classList.add('printing-active');
    window.addEventListener('afterprint', handleAfterPrint);

    const timer = setTimeout(() => {
      window.print();
    }, 500);

    return () => clearTimeout(timer);
  }, [getPrescriptionToPrint]);

  return (
    <div className="container d-none d-print-block">
      <div className="text-center mt-5">
        <h5 style={{ textTransform: 'uppercase', letterSpacing: '0.05em' }}>
          Receituário de Controle Especial
        </h5>
      </div>

      <div className="mt-4" style={{ display: 'flex', gap: '24px', alignItems: 'flex-start' }}>
        <div style={{ flex: 1, border: '1px solid #000', padding: '10px', fontSize: '0.8rem' }}>
          <p style={{ fontWeight: 'bold', marginBottom: '6px', fontSize: '0.85rem' }}>
            IDENTIFICAÇÃO DO EMITENTE
          </p>
          <p style={{ marginBottom: '4px' }}>{prescriptionToPrint?.nomeDoDentista}</p>
          <p style={{ marginBottom: '4px' }}>{prescriptionToPrint?.clinicName}</p>
          <p style={{ marginBottom: '4px' }}>{prescriptionToPrint?.clinicAddress}</p>
          <p style={{ marginBottom: '4px' }}>{prescriptionToPrint?.clinicCityName}</p>
          <p style={{ marginBottom: 0 }}>
            {prescriptionToPrint?.clinicPhoneNumber} — {prescriptionToPrint?.clinicEmail}
          </p>
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-end',
            fontSize: '0.85rem',
            fontWeight: 'bold',
            gap: '6px',
          }}
        >
          <p style={{ marginBottom: 0 }}>1ª VIA FARMÁCIA</p>
          <p style={{ marginBottom: 0 }}>2ª VIA PACIENTE</p>
        </div>
      </div>

      <div className="mt-3">
        <p>Paciente: {prescriptionToPrint?.nomeDoPaciente}</p>
      </div>

      <div className="mt-5">
        {prescriptionToPrint?.medicamentos.map((medicamento) => {
          return (
            <div class="d-flex">
              <div class="flex-1">
                <p class="mb-0">
                  <strong>
                    {medicamento.nome} - {medicamento.descricaoQuantidade}
                  </strong>
                </p>
                <p class="fs--1 mb-0 text-600">{medicamento.posologia}</p>
                <div class="border-bottom border-dashed my-3"></div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="text-center mt-5">
        <p>Data: {prescriptionToPrint?.data}</p>
        <p>______________________________</p>
        <p>Assinatura do Profissional</p>
      </div>

      <div className="mt-5" style={{ display: 'flex', gap: '24px' }}>
        <div style={{ flex: 1, border: '1px solid #000', padding: '12px', minHeight: '140px' }}>
          <p style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '0.85rem' }}>
            IDENTIFICAÇÃO DO COMPRADOR
          </p>
          <p style={{ fontSize: '0.8rem', marginBottom: '6px' }}>Nome:</p>
          <p style={{ fontSize: '0.8rem', marginBottom: '6px' }}>Identidade:</p>
          <p style={{ fontSize: '0.8rem', marginBottom: '6px' }}>Órgão emissor:</p>
          <p style={{ fontSize: '0.8rem', marginBottom: '6px' }}>Endereço:</p>
          <p style={{ fontSize: '0.8rem', marginBottom: 0 }}>Cidade/UF:</p>
        </div>
        <div
          style={{
            flex: 1,
            border: '1px solid #000',
            padding: '12px',
            minHeight: '140px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <p style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '0.85rem' }}>
            IDENTIFICAÇÃO DO FORNECEDOR
          </p>
          <div style={{ flex: 1 }} />
          <div style={{ fontSize: '0.8rem' }}>
            <p style={{ marginBottom: '4px' }}>______________________________</p>
            <p style={{ marginBottom: '4px' }}>ASSINATURA DO FARMACÊUTICO</p>
            <p style={{ marginBottom: 0 }}>DATA __/__/____</p>
          </div>
        </div>
      </div>
    </div>
  );
}
